module.exports = __webpack_public_path__ + "img/hide.edc5c97a.svg";